import React, { Component } from 'react';
import '../../css/common/Button.css';

class Errors extends Component {

  render() {
    var errors = this.props.validation && this.props.validation.errors ? this.props.validation.errors : [];
    var style  = this.props.style  || { marginBottom: 10, marginTop: 10 };
    if (errors.length > 0) {

      const errorRows = errors.map((error, index) => {
        return <span key={index} style={{ fontSize: 14, color: 'red' }}>{ error }</span>
      });

      return <div className='flex-container-column flex-center-align' style={style}>
        { errorRows }
      </div>
    }

    return null;
  }

}

export default Errors
